import Car from './car.model';
import {OfferModel} from './offer.model';
import {AvailableAppointment} from './appointment.model';

export enum ROLE {
    ASSISTANT = 'assistant',
    USER = 'user',
}

interface Message {
    id?: number;
    role: ROLE.ASSISTANT | ROLE.USER;
    text: string;
    cars?: Car[];
    offers?: OfferModel[];
    locations?: string[];
    available_appointments?: AvailableAppointment[];
}
export default Message;

export interface MessageResponse {
    messages: {message: Message}[];
    lead?: Record<string, any>;
    is_conversion?: boolean;
}

export const USER_CLASSES = 'bg-primary text-white items-start flex-row-reverse max-w-3/4';
export const ASSISTANT_CLASSES = 'max-w-3/4 text-grey-700 items-start bg-gray-100';
